import { ProjectMemberDto, TenantUserDto } from '../api/model';

/**
 * A project member in the shape the user picker takes. The badge the picker
 * shows is the member's role in this project, not their tenant-wide role -
 * someone can lead one project and just take part in another. No project
 * role, no badge.
 */
export function memberAsUser(member: ProjectMemberDto): TenantUserDto {
  return {
    id: member.userId,
    username: member.username,
    firstName: member.firstName,
    lastName: member.lastName,
    // UserPicker renders this field as the badge
    tenantRoleDisplayName: member.projectRoleDisplayName,
  };
}
